<template>
  <div class="country-box">
    <div class="country-box--title">{{ title }}</div>
    <div class="country-box--list">
      <span v-for="(c, index) in list" :key="index">{{ formatLabel(c,index) + " " }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: false,
    },
  },
  methods:{
    formatLabel(c,index){
        const isLast = index === this.list.length - 1;
        return !isLast ? `${c}, ` :`${c}.`;

    }
  }
};
</script>

<style lang="scss" scoped>
.country-box {
  height: fit-content;
  width: 100%;
  color: $ui-white;
  margin-bottom: toRem(22);

  &--title {
    @include dida-M;
    margin-bottom: toRem(10);
    font-weight: 700;
  }

  &--list {
    span {
      @include p-s;
      opacity: 0.8;
      line-height: 21px;
    }
  }
}
</style>